module.exports = __webpack_public_path__ + "static/media/xlsxIcon.b0063442.svg";